import * as React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';

const paperSx = {
    bgcolor: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 3,
    boxShadow: '0 24px 60px rgba(0,0,0,0.3)',
    minWidth: 400,
};

export default function FileExistConformation({ open, setOpen, doUpload }) {
    const handleClose = () => setOpen(false);
    const replace  = () => { doUpload();       handleClose(); };
    const saveAsNew = () => { doUpload(true);  handleClose(); };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth PaperProps={{ sx: paperSx }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, pb: 1 }}>
                <Box sx={{
                    width: 38, height: 38, flexShrink: 0, borderRadius: 2,
                    bgcolor: 'rgba(251,191,36,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <WarningAmberRoundedIcon sx={{ fontSize: 22, color: '#fbbf24' }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography sx={{ color: 'var(--text-1)', fontWeight: 700, fontSize: 16, lineHeight: 1.3 }}>
                        File Already Exists
                    </Typography>
                    <Typography sx={{ color: 'var(--text-3)', fontSize: 12, mt: 0.3 }}>
                        A file with the same name exists in this location
                    </Typography>
                </Box>
                <IconButton size="small" onClick={handleClose}
                    sx={{ color: 'var(--text-3)', '&:hover': { color: 'var(--text-1)' }, mt: -0.5 }}>
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 0.5, pb: 2.5 }}>
                <Typography sx={{ color: 'var(--text-2)', fontSize: 13.5, lineHeight: 1.6 }}>
                    What would you like to do with the uploaded file?
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2.5, gap: 1.5, justifyContent: 'flex-end' }}>
                <Button
                    onClick={handleClose}
                    sx={{ color: 'var(--text-3)', textTransform: 'none', fontWeight: 500, '&:hover': { color: 'var(--text-1)' } }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={replace}
                    variant="outlined"
                    startIcon={<SyncAltOutlinedIcon sx={{ fontSize: 16 }} />}
                    sx={{
                        textTransform: 'none', fontWeight: 600, borderRadius: 2, px: 2.5,
                        color: '#f87171', borderColor: 'rgba(248,113,113,0.35)',
                        '&:hover': { borderColor: '#f87171', bgcolor: 'rgba(248,113,113,0.08)' },
                    }}
                >
                    Replace
                </Button>
                <Button
                    onClick={saveAsNew}
                    variant="contained"
                    startIcon={<ContentCopyOutlinedIcon sx={{ fontSize: 16 }} />}
                    sx={{
                        textTransform: 'none', fontWeight: 600, borderRadius: 2, px: 2.5,
                        bgcolor: '#7c6af7', color: '#fff',
                        '&:hover': { bgcolor: '#6a58e0' },
                    }}
                >
                    Save as New
                </Button>
            </DialogActions>
        </Dialog>
    );
}
